<template>
	<div :class="['cont-box', smallScreen && 'smallScreen']" v-show="showPage">
		<div id="code" ref="code" style="opacity:1">
			<div class="code" :class="{ special: isSelectedSpecial }">
				<div class="flex76"></div>
				<div class="logo-img">
					<img src="../assets/images/logo.svg" alt />
				</div>
				<div class="flex91"></div>
				<div class="succ" :class="{ special: isSelectedSpecial, small: smallScreen }">
					预约成功
				</div>
				<div class="title">{{ projectName }}</div>
				<div class="date" :class="{ special: isSelectedSpecial }">{{ date }} {{ time }}</div>
				<div class="store">{{ store }}</div>
				<div class="address">{{ address }}</div>
				<div class="append" v-if="addition">{{ addition }}</div>

				<div class="isSelectedSpecial" v-show="isSelectedSpecial">
					<div class="text1">已预约{{ bookingTimeValue }}的彩妆秀</div>
					<div class="text2">请按时抵达体验区</div>
				</div>

				<div
					class="code-img"
					:class="{ special: isSelectedSpecial, small: smallScreen }"
					id="code-img"
					ref="codeImg"
				>
					<canvas id="canvas" style="display:block"></canvas>
					<div class="codeImg">
						<img src="../assets/images/codeImg.png" alt />
					</div>
				</div>

				<div class="into">请于活动现场出示预约二维码入场</div>
				<div class="save">长按保存预约信息</div>
				<div class="bottom-flex91"></div>
			</div>
		</div>
		<!-- <div class="bg"></div> -->
		<img :src="src" alt id="pageImg" @click="clear" />
	</div>
</template>
<script>
import { Utils } from '@/assets/js/utils'
import { checkDiscern } from '@/assets/js/api'
import Html2Canvas from 'html2canvas'
import QRCode from 'qrcode'
import moment from 'moment'

export default {
	data() {
		return {
			store: '',
			address: '',
			addition: '',
			src: '',
			date: '5月1日',
			time: '周五',
			count: 0,
			channel: '',
			discern: null,
			showPage: false,
			isSelectedSpecial: true,
			margin: {
				succ: 66,
				date: 32,
				code: 31,
			},
			bookingTimeValue: 0,
			smallScreen: false,
		}
	},
	created() {
		//根据discern获取用户信息
		this.channel = this.$route.query.channel || Utils.getLocal().channel
		this.sceneId = this.$route.query.sceneId || Utils.getLocal().sceneId
		this._checkDiscern()
	},
	mounted() {
		this.$nextTick(() => {
			document.querySelector('#app').style.height = '100%'
			if (document.body.clientHeight <= 598) {
				this.smallScreen = true
			}
		})
	},
	methods: {
		clear() {
			// this.count = this.count + 1;
			// if (this.count > 20) {
			//   localStorage.removeItem("n5-holiday-podium");
			//   location.href = '?channel=' + this.channel + '&sceneId=' + this.sceneId
			// }
		},
		_cityInfo(cityObj, scene) {
			let y = Number(cityObj.bookingTimeValue.slice(0, 4))
			let m = Number(cityObj.bookingTimeValue.slice(4, 6))
			let d = Number(cityObj.bookingTimeValue.slice(6, 8))
			let wholeDay = y + cityObj.bookingTimeValue.slice(4, 8)
			let w = Number(moment(wholeDay).format('d'))
			w = Utils.getWeekName(w)
			this.date = `${m}月${d}日`
			this.time = `周${w}`
			this.store = scene.site
			let address = scene.address
			let index = address.indexOf('_') // 换行分割显示
			if (index > -1) {
				this.address = address.slice(0, index)
				this.addition = address.slice(index + 1, address.length)
			} else {
				this.address = address
			}
		},
		async _checkDiscern() {
			let discern = this.$route.query.discern || Utils.getLocal().discern
			this.discern = discern
			let sceneId = this.sceneId
			try {
				const { data } = await checkDiscern({
					discern,
					sceneId,
				})
				const { message, payload } = data
				if (message.code == '00000') {
					const { booking, scene } = payload
					this._cityInfo(booking, scene)
					this.bookingTimeValue = Number(booking.bookingSpecialServeValue.slice(0, 2)) + ':00'
					this.isSelectedSpecial = booking.isSelectedSpecial > 0 ? true : false
					this.discern = booking.discern
					this.channel = booking.channel
					this.sceneId = booking.sceneId
					this.campaignCode = scene.campaignCode
					this._codeImg()
				} else {
					localStorage.removeItem('n5-holiday-podium')
					location.href = '?channel=' + this.channel + '&sceneId=' + sceneId
				}
			} catch (err) {
				console.log(err)
				localStorage.removeItem('n5-holiday-podium')
				location.href = '?channel=' + this.channel + '&sceneId=' + sceneId
			}
		},
		_codeImg() {
			let self = this
			var host =
				'https://vip.chanel.com.cn/index.php?s=/addon/Api/Activity/hx/campaignid/' +
				this.campaignCode +
				'/sign/' +
				this.discern +
				'.html'
			console.log(host)
			QRCode.toCanvas(document.getElementById('canvas'), host, { margin: 1 }, function(error) {
				if (error) console.error(error)
				// 不加定时器获取不到dom
				setTimeout(() => {
					self._pageCanvas()
				}, 500)
			})
			this.showPage = true
		},
		_pageCanvas() {
			let self = this
			Html2Canvas(this.$refs.code, { allowTaint: true }).then(function(canvas) {
				self.src = canvas.toDataURL('image/png')
				console.log(self.src)
			})
		},
	},
}
</script>
<style lang="stylus" scoped>
#canvas {
  width: 100% !important;
  height: 100% !important;
}

.cont-box {
  width: 100%;
  height: 100%;

  #pageImg {
    max-width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
    opacity: 0;
  }

  .bg {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100vh;
    background: #fff;
  }
}

#code {
  width: 100%;
  height: 100%;
}

.code {
  text-align: center;
  box-sizing: border-box;
  background: transparent;
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;

  &.special {
    top: 5px;
  }

  .logo-img {
    width: 150px;
    margin: 0 auto;


    img {
      max-width: 100%;
    }
  }

  .succ {
    font-size: 18px;
    line-height: 18px;
    letter-spacing: 0.56px;
    transform: translateY(2px);
  }

  .title {
    font-size: 24px;
    line-height: 24px;
    margin-top: 16px;
    white-space: nowrap;
    letter-spacing: 1px;
    font-family: PingFangSC-Medium, 'PingFangH';
    transform: translateY(3px);
    // .num {
    //   display: inline-block;
    //   font-size: 28.5px;
    //   letter-spacing: 1px;
    //   font-family: ABChanelCorpo-Light, 'PingFangH';
    //   transform translate(0px, 2px)
    // }
    img {
        width: 273px
        margin: 0 auto;
    }
  }
  .title-img {
    margin-top: 16px
    img {
      height: 24px
    }
  }

  .date {
    font-size: 16px;
    line-height: 16px;
    height: 16px;
    margin-top: 44px;
    letter-spacing 0.5px;
    font-family: PingFangSC-Medium, 'PingFangH';
    transform: translateY(3px);
    &.special {
      margin-top: 32px;
    }
  }

  .store {
    font-size: 16px;
    line-height: 16px;
    height: 16px;
    margin-top: 11px;
    color: #919191;
    letter-spacing: 0.5px;
    transform: translateY(2px);
  }

  .address {
    font-size: 16px;
    line-height: 16px;
    height: 16px;
    margin-top: 11px;
    color: #919191;
    letter-spacing: 0.5px;
    white-space: pre-line;
    transform: translateY(1px);
  }

  .append {
    color: #999999;
    font-size: 16px;
    height: 16px;
    line-height: 16px;
    margin-top: 5px;
  }

  .isSelectedSpecial {
    font-size: 16px;
    line-height: 16px;
    margin-top: 32px;
    letter-spacing: 0.4px;

    .text1 {
      font-family: PingFangSC-Medium, 'PingFangH';
    }

    .text2 {
      color: #999999;
      margin-top: 10px;
    }
  }

  .code-img {
    width: 87px;
    height: 87px;
    // margin: 45px auto 18px;
    margin: 47px auto 16px;
    position: relative;

    &.special {
      margin-top: 31px;
    }

    &.small {
      margin-bottom: 20px;
    }

    .codeImg {
      width: 25px;
      height: 25px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    img {
      max-width: 100%;
    }
  }

  .into {
    font-size: 14px;
    line-height: 14px;
    color: #999;
    letter-spacing: 0.5px;
  }

  .save {
    font-size: 14px;
    line-height: 14px;
    color: #999;
    margin-top: 8px;
    letter-spacing: 0.5px;
    transform: translateY(2px);
  }
}

.flex76 {
  width 100%;
  flex:76;
}
.smallScreen .flex76 {
  flex: 45;
}
.flex91 {
  width 100%;
  flex:91;
}
.smallScreen .flex91 {
  flex: 58;
}
.bottom-flex91 {
  width 100%;
  flex:91;
}
.smallScreen .bottom-flex91 {
  flex: 62;
}
.smallScreen .code .title {
  transform:translateY(1px);
}
.smallScreen .code .logo-img {
  transform:translateY(-1px);
}
.smallScreen .code .code-img {
  margin-bottom: 20px;
  transform: translateY(-3px);
}
.smallScreen .into {
  transform: translateY(-2px);
}
.smallScreen .code {
  .succ {
    transform: translateY(0px);
  }
  .title {
    transform: translateY(1px);
  }
  .date {
    transform: translateY(1px);
  }
  .store {
    transform: translateY(0px);
  }
  .address {
    transform: translateY(-1px);
  }
  .save {
    transform: translateY(0px);
  }
}
</style>
